export default __webpack_public_path__ + "static/media/faq-pointer.3dbf8783.svg";